export class Cooeperative {
  nom: string = "";
  localisation: string = "";
  longitude: string = "";
  latitude: string = "";
  description: string = "";
  admin_id: string = "";
  cooperative_id: string = "";
  pays_id: string = "";
  superadmin_id: string = "";

  private errorMessage: string;

  constructor() {
    this.errorMessage = "";
  }

  // Récupérer le message d'erreur
  getErrorMessage(): string {
    return this.errorMessage;
  }

  // Vérifier si on peut sauvegarder
  canSave(): boolean {
    // Vérification du nom
    if (!this.nom || this.nom.trim() === "") {
      this.errorMessage = "Veuillez saisir le nom de la coopérative";
      return false;
    }

    // Vérification de la localisation
    if (!this.localisation || this.localisation.trim() === "") {
      this.errorMessage = "Veuillez saisir la localisation de la coopérative";
      return false;
    }

    // Vérification de la longitude
    if (!this.longitude ) {
      this.errorMessage = "Veuillez saisir la longitude";
      return false;
    }

    // Vérification de la latitude
    if (!this.latitude ) {
      this.errorMessage = "Veuillez saisir la latitude";
      return false;
    }

    // Vérification de la description
    if (!this.description || this.description.trim() === "") {
      this.errorMessage = "Veuillez fournir une description";
      return false;
    }

    // Vérification de l'identifiant administrateur
    // if (!this.admin_id || this.admin_id.trim() === "") {
    //   this.errorMessage = "Veuillez sélectionner un administrateur";
    //   return false;
    // }

    // Si tous les champs sont valides
    this.errorMessage = ""; // Réinitialiser le message d'erreur
    return true;
  }
}
